// swiperInit.js
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.timeline-section');
    const mobileBreakpoint = 991;

    sections.forEach(section => {
        const tabSliderEl = section.querySelector('.ts-tab-slider');
        const tabSlides = tabSliderEl.querySelectorAll('.swiper-slide');
        const contentSlider = section.querySelector('.ts-tab-content-slider');
        const mediaSliderEl = section.querySelector('.ts-tab-media-slider');

        const prevBtn = section.querySelector('.ts-button-prev');
        const nextBtn = section.querySelector('.ts-button-next');

        let swipers = [];
        let mediaSwiper = null;

        const initSwiper = () => {
            if (!tabSliderEl.swiper) {
                swipers.push(
                    new Swiper(tabSliderEl, {
                        slidesPerView: 'auto',
                        spaceBetween: 14,
                    }),
                );
            }
        };

        const destroySwiper = () => {
            swipers.forEach(swiper => swiper.destroy(true, true));
            swipers = [];
        };

        const handleResize = () => {
            window.innerWidth <= mobileBreakpoint ? initSwiper() : destroySwiper();
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        // Main content swiper
        const mainContentSwiper = new Swiper(contentSlider, {
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            autoHeight: true,
            allowTouchMove: true,
            breakpoints: {
                992: {
                    allowTouchMove: false,
                    autoHeight: false,
                },
            },
        });

        // Media swiper (if exists)
        if (mediaSliderEl) {
            mediaSwiper = new Swiper(mediaSliderEl, {
                slidesPerView: 1,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                allowTouchMove: false,
                autoHeight: true,
                thumbs: {
                    swiper: mainContentSwiper,
                },
                breakpoints: {
                    992: {
                        autoHeight: false,
                    },
                },
            });
        }

        // 🔹 Update navigation buttons
        const updateNavState = () => {
            if (!prevBtn || !nextBtn) {return;}
            prevBtn.classList.toggle('swiper-button-disabled', mainContentSwiper.isBeginning);
            nextBtn.classList.toggle('swiper-button-disabled', mainContentSwiper.isEnd);
        };

        updateNavState();
        mainContentSwiper.on('slideChange', () => {
            updateNavState();
            updateActiveTab(mainContentSwiper.activeIndex);
        });

        // ✅ Custom navigation
        if (prevBtn && nextBtn) {
            prevBtn.addEventListener('click', () => {
                if (mainContentSwiper.isBeginning) {return;}
                mainContentSwiper.slidePrev();
                if (mediaSwiper) {mediaSwiper.slidePrev();}
            });

            nextBtn.addEventListener('click', () => {
                if (mainContentSwiper.isEnd) {return;}
                mainContentSwiper.slideNext();
                if (mediaSwiper) {mediaSwiper.slideNext();}
            });
        }

        // 🔹 Update active tab slide
        const updateActiveTab = (index) => {
            tabSlides.forEach((slide, i) => {
                slide.classList.toggle('is-active', i === index);
            });
        };

        // 🔹 Tab click → slide main content & media swiper
        tabSlides.forEach((slide, index) => {
            slide.addEventListener('click', () => {
                mainContentSwiper.slideTo(index);
                if (mediaSwiper) {mediaSwiper.slideTo(index);}
                updateActiveTab(index);
            });
        });

        // Initial active tab
        updateActiveTab(0);
    });
});